import { Component, EventEmitter, forwardRef, OnDestroy, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, UntypedFormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { Subscription } from 'rxjs';
import { DisplayProductDataService } from '../display-product-data.service';
import { MaterialCreateComponent } from '../material-create/material-create.component';

@Component({
    selector: 'app-material-select-new',
    templateUrl: './material-select-new.component.html',
    styleUrls: ['./material-select-new.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => MaterialSelectNewComponent),
            multi: true
        }
    ],
    standalone: false
})
export class MaterialSelectNewComponent implements OnInit, OnDestroy, ControlValueAccessor {

  materialList = [];
  materialStore = '';
  private subscriptions: Subscription[] = [];

  @Output() selectionChange = new EventEmitter<MatSelectChange>();

  selectListControl = new UntypedFormControl({ value: '', disabled: true });

  constructor(
    private dialog: MatDialog,
    private displayProductData: DisplayProductDataService
  ) { }

  ngOnInit(){
    const onGetDataSubscription = this.displayProductData.getMaterialList()
    .subscribe(allMaterialLists => this.materialList = allMaterialLists);
    this.subscriptions.push(onGetDataSubscription);
  }

  materialChangeAction(event) {
    if ( event.value === 'create' ) {
      const dialogRef = this.dialog.open(MaterialCreateComponent, {
        width: '1000px',
        maxWidth: '96vw',
        disableClose: true,
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.materialList.unshift(result);
          this.selectListControl.setValue(result.name);
        } else {
          this.selectListControl.setValue(this.materialStore);
        }
      });
    } else if ( event.value === 'empty' ) {
      this.materialStore = '';
      this.selectListControl.reset('');
    } else {
      this.materialStore = event.value;
    }

    this.selectionChange.emit(event);
  }

  // model --> view
  writeValue(value: string): void {
    if (value) {
      this.materialStore = value;
      this.selectListControl.setValue(value, { emitEvent: false });
    } else {
      this.selectListControl.reset('');
    }
  }

  // view --> model
  registerOnChange(fn: (value: string) => void) {
    const onChangeSubscription = this.selectListControl.valueChanges.subscribe(fn);
    this.subscriptions.push(onChangeSubscription);
  }

  registerOnTouched(fn: () => void) {
    this.onTouched = fn;
  }

  onTouched: () => void = () => {};

  ngOnDestroy() {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }
}
